import { render } from "./TaskDetails.vue?vue&type=template&id=c2766cc2&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=c2766cc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2766cc2"

export default script